import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";

export async function getPackageMetricData(stationCode) {
    const request = {
        resourcePath: "/os/getPackageMetricData",
        httpMethod: "post",
        processName: "oculus",
        requestBody: {
            "nodeId": stationCode,
            "view": "QUICK_COMMERCE_VIEW"
        }
    };

    const result = await getAPIGatewayDataFromParent(request);
    if (result.status === 200) {
        return result.data;
    } else {
        throw new Error(`API non-200 response: ${result.status}`);
    }
}



// WEBPACK FOOTER //
// ./src/commons/api/GetPackageMetricData.js